import createReactClass from 'create-react-class';
import htmr from 'htmr';
import { utils } from '../../js/utils';

/* Same behaviour as the built-in checkbox-group, but laid out as a flex grid so a
   single option can span the full width via `fullWidth: true`. The built-in type
   renders a fixed <table> with one <td> per column, which cannot be spanned. */
export default function (dependencies) {
  const COLUMN_GAP = 2;

  const CheckboxGroupColumns = createReactClass({
    elements: {},

    render() {
      const config = this.props.field.config;
      const columns = config.numberOfColumns || 2;

      return (
        <div className="lz-input-wrapper">
          <label>{utils.parseLabel(config.label, this.props)}</label>
          <span
            className="lz-extratext"
            dangerouslySetInnerHTML={{ __html: config.tinyLabel }}
          ></span>
          <div
            className={'leazard-lanes' + this.props.errorClass}
            style={{ display: 'flex', flexWrap: 'wrap', columnGap: `${COLUMN_GAP}px` }}
          >
            {config.options.map((option, index) => {
              return this.makeCheckbox(option, index, config.id, columns);
            })}
          </div>
          {this.props.makeErrors(this.props.field.state.errors)}
        </div>
      );
    },

    makeCheckbox(option, index, groupID, columns) {
      const field = this.props.field;
      const { value, display, exclusive, tinyText, fullWidth } = option;
      const id = this.props.tools.uniqueId(String(field.config.id) + value);
      const width = fullWidth
        ? '100%'
        : `calc(${100 / columns}% - ${(COLUMN_GAP * (columns - 1)) / columns}px)`;

      return (
        <div key={index} className="lz-input-wrapper" style={{ flex: `0 0 ${width}` }}>
          <div className="lz-choose">
            <input
              id={id}
              type="checkbox"
              checked={this.isCheckboxSelected(value)}
              onChange={this.selectCheckbox(value, exclusive)}
              ref={(el) => (this.elements[groupID + index] = el)}
              onKeyDown={this.onKey(index, groupID, value, exclusive)}
            />
            <label htmlFor={id}>
              <div className="lz-table lz-table-middle">
                <div className="lz-table-cell">
                  <div className="check-1-2-3">
                    <i className="fa fa-check"></i>
                  </div>
                </div>
                <div className="lz-table-cell">
                  {htmr(display)}
                  {tinyText && (
                    <span style={{ display: 'block', fontSize: '13px' }}>{htmr(tinyText)}</span>
                  )}
                </div>
              </div>
            </label>
            <span className="lz-input-bar"></span>
          </div>
        </div>
      );
    },

    isCheckboxSelected(name) {
      return this.props.field.state.value.indexOf(name) !== -1;
    },

    onKey(index, id, value, exclusive) {
      return (event) => {
        const { options } = this.props.field.config;
        const numberOfTabs = options.length;
        const changeFocus = (index) => {
          this.elements[id + index].focus();
        };

        let next = index;
        if (event.key === 'ArrowRight') {
          next = index === numberOfTabs - 1 ? 0 : ++index;
          changeFocus(next);
        } else if (event.key === 'ArrowLeft') {
          next = index === 0 ? numberOfTabs - 1 : --index;
          changeFocus(next);
        } else if (event.key === 'Enter') {
          this.selectCheckbox(value, exclusive)();
        }
      };
    },

    selectCheckbox(option, exclusive) {
      return function () {
        const field = this.props.field;
        const config = this.props.field.config;
        const indexOfOption = field.state.value.indexOf(option);
        const exclusiveList = config.options
          .filter(({ exclusive }) => exclusive)
          .map(({ value }) => value);

        if (indexOfOption !== -1) {
          field.state.value.splice(indexOfOption, 1);
        } else {
          const existingExclusive = field.state.value.reduce((bool, value) => {
            return bool || exclusiveList.indexOf(value) !== -1;
          }, false);
          if (existingExclusive || exclusive) {
            field.state.value = [option];
          } else {
            field.state.value.push(option);
          }
        }
        this.forceUpdate();
        this.props.onUpdate();
      }.bind(this);
    },
  });

  const html = (props) => <CheckboxGroupColumns {...props} {...dependencies} />;

  return {
    html,
    config: {
      validators: ['choose:1'],
      stateType: 'array',
      defaultValue: null,
      defaultValueBehaviour: 'first',
      numberOfColumns: 2,
    },
  };
}
